export enum PlatformType {
    Web = 'web',
    Flutterweb = 'flutter-web',
    Flutterios = 'flutter-ios',
    Flutterandroid = 'flutter-android',
    Flutterlinux = 'flutter-linux',
    Fluttermacos = 'flutter-macos',
    Flutterwindows = 'flutter-windows',
    Appleios = 'apple-ios',
    Applemacos = 'apple-macos',
    Applewatchos = 'apple-watchos',
    Appletvos = 'apple-tvos',
    Android = 'android',
    Unity = 'unity',
}